import React from 'react';
import styles from './LoadingIndicator.module.scss';

export const LoadingIndicator = () => {
  return <div className={styles.loadingIndicator} />;
};
